import React from 'react';
import { oneLine } from 'common-tags';

interface ScopeProps {
  className?: string;
  children: React.ReactElement;
}

interface ScopedStylesResult {
  className?: string;
  styles: React.FC;
  wrapClassNames: (..._classNames: (string | undefined)[]) => string;
}

export function resolveScopedStyles(scope: React.ReactElement<ScopeProps>): ScopedStylesResult {
  if (!scope.type || scope.type !== 'scope') {
    throw new TypeError(oneLine`
      Style resolver expexting <style jsx /> node to be wrapped
      in <scope> element.
    `);
  }

  return {
    className: scope.props.className,
    styles: () => scope.props.children,
    wrapClassNames: (..._classNames) => [
      scope.props.className,
      ..._classNames,
    ].filter(Boolean).join(' '),
  };
}
